import { apiClient } from './client';
import type { User, LoginCredentials, LoginResponse, AuthTokens } from '../../types';

export const authService = {
  login: async (credentials: LoginCredentials): Promise<LoginResponse> => {
    return apiClient.post<LoginResponse>('/api/v1/auth/login', credentials);
  },

  logout: async (refreshToken: string): Promise<void> => {
    await apiClient.post('/api/v1/auth/logout', { refreshToken: refreshToken });
  },

  refreshToken: async (refreshToken: string): Promise<{ tokens: AuthTokens }> => {
    return apiClient.post<{ tokens: AuthTokens }>('/api/v1/auth/refresh', {
      refreshToken: refreshToken,
    });
  },

  getCurrentUser: async (): Promise<User> => {
    return apiClient.get<User>('/api/v1/auth/me');
  },

  changePassword: async (data: { currentPassword: string; newPassword: string; confirmNewPassword: string }): Promise<{ message: string }> => {
    return apiClient.post<{ message: string }>('/api/v1/auth/change-password', data);
  },

  forgotPassword: async (email: string): Promise<{ message: string }> => {
    return apiClient.post<{ message: string }>('/api/v1/auth/forgot-password', { email });
  },

  resetPassword: async (data: { token: string; newPassword: string; confirmNewPassword: string }): Promise<{ message: string }> => {
    return apiClient.post<{ message: string }>('/api/v1/auth/reset-password', data);
  },
};
